import ProductHierarchy from './table/table.vue';

export default ProductHierarchy;
